import { Authenticator, Heading } from "@aws-amplify/ui-react";
import "@aws-amplify/ui-react/styles.css";
import { generateClient } from "aws-amplify/api";
import "bootstrap/dist/css/bootstrap.min.css";
import { Alert, Container, Image } from "react-bootstrap";
import { useLocation } from "react-router-dom";
import "./App.css";
import Router from "./components/Router";
import TopNav from "./components/TopNav";
import Prelaunch from "./components/Prelaunch";

export const client = generateClient({
  authMode: "userPool",
});

let isPrelaunch = false;

const App = () => {
  const { search } = useLocation();
  if (search.includes("prelaunch=false")) {
    isPrelaunch = false;
  }

  const signUpFields = {
    signUp: {
      email: {
        order: 1,
      },
      password: {
        order: 2,
      },
      confirm_password: {
        order: 3,
      },
      "custom:affiliate": {
        placeholder: "If someone referred you, enter their code here",
        isRequired: false,
        label: "Referrer Affiliate ID",
        order: 4,
      },
    },
  };
  if (isPrelaunch) {
    return <Prelaunch />;
  }
  return (
    <Authenticator
      loginMechanisms={["email"]}
      signUpAttributes={["email"]}
      formFields={signUpFields}
      components={{
        Header() {
          return (
            <div style={{ textAlign: "center", marginBottom: "10px" }}>
              <Image
                alt="StubMiner logo"
                src={"https://stubminer.com/images/logo.png"}
                height={175}
              />
            </div>
          );
        },
        SignIn: {
          Header() {
            return (
              <>
                <div style={{ padding: "5px 10px 0px 10px" }}>
                  <Alert variant="success">
                    <Alert.Heading>2026 sign-up bonus!</Alert.Heading>
                    <p>
                      The first time you create a subscription using a referral
                      code, you'll be granted a <strong>$5 credit</strong> that
                      can be automatically applied to any other purchase or
                      payment you make.
                    </p>
                  </Alert>
                </div>
                <div style={{ padding: "10px 20px 0px 20px" }}>
                  <p style={{ fontSize: "13px" }}>
                    If you had an account with us in '25, you'll need to sign up
                    for a new account this year.
                  </p>
                </div>
              </>
            );
          },
        },
        SignUp: {
          Footer() {
            const qsArr = search.split("?");
            const qs = qsArr[qsArr.length - 1];
            const qsEntriesArr = qs.split("&");
            const affiliateEntry = qsEntriesArr.find((q) =>
              q.startsWith("affiliate="),
            );
            if (affiliateEntry) {
              const affiliate = affiliateEntry.split("=")[1];
              const nodes = document.getElementsByName("custom:affiliate");
              if (nodes.length > 0) {
                nodes[0].setAttribute("value", affiliate);
              }
            }
            return (
              <Heading padding={15} textAlign="center">
                By signing up, you agree to our{" "}
                <a href="https://stubminer.com/terms.html#terms" target="_new">
                  Terms & Conditions
                </a>
              </Heading>
            );
          },
        },
      }}
    >
      {() => (
        <div>
          <TopNav />
          <Alert variant="warning" dismissible className="mb-0 rounded-0">
            <strong>Notice (4/5/26):</strong> We have heard reports of some
            account suspensions from our customers. Proceed at your own risk.
          </Alert>
          <Container>
            <Router />
          </Container>
        </div>
      )}
    </Authenticator>
  );
};

export default App;
